var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M878.7 596.8l9-8.4h1.6v129h-1.8L877 707.2V595z",
    fill: "#01A8C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M877 577l10.7 11.4-9 8.4-1.7-1.8zM887.5 717.4l-8.5 8.9-2-2v-17.1z",
    fill: "#01A8C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M877 724.3v11.9c0 31.1-25.2 56.4-56.4 56.4H171.4c-26 0-47.1-21.2-47.1-47.1V313.7c0-20.9 17-38 37.9-38h260l148.4 145.9-33.1 33 40.1 40.1v56h56l39.5 39.5 32.6-32.5L877 724.3z m-418.5-63.5v-41c0-18.6-15.1-33.8-33.8-33.8h-32.2c-18.7 0-33.8 15.3-33.8 33.8v41c0 18.7 15.1 33.8 33.8 33.8h32.2c18.7 0.1 33.8-15.1 33.8-33.8z m-230.6 45.6l218.5-264.6-9.5-7.9-218.5 264.6 9.5 7.9z m81.5-201.9v-36.9c0-19.8-16.1-35.9-35.9-35.9h-28.2c-19.8 0-35.9 16.1-35.9 35.9v36.9c0 19.7 16.1 35.8 35.9 35.8h28.2c19.7 0 35.9-16.1 35.9-35.8z",
    fill: "#8CDDE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M877 577v18L776 487.3l8.7-8.8z",
    fill: "#01A8C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M833 275.7H584l-11.3-12.3H833c31.1 0 56.4 25.4 56.4 56.5v268.6h-1.6L877 577V319.9c0-24.4-19.7-44.2-44-44.2z",
    fill: "#01A8C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M769.3 431.1l22.8 22.7-22.8 22.8z",
    fill: "#EF4668"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M784.7 478.5l-8.7 8.8-5.9-6.3 8.9-8.5z",
    fill: "#01A8C2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M776 487.3L877 595v112.2L716.3 550.7h53v-56.8z",
    fill: "#FFF0C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M809.5 453.8l-24.8 24.7-5.7-6-8.9 8.5 5.9 6.3-6.7 6.6v-17.3l22.8-22.8-22.8-22.7v-17.3zM769.3 476.6v17.3L757 506.2v-17.3z",
    fill: "#01A8C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M757 418.8l12.3 12.3v45.5L757 488.9z",
    fill: "#EF4668"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M757 418.8v-17.3l12.3 12.3v17.3z",
    fill: "#01A8C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M757 506.2v32.1h-32zM757 418.8v70.1l-49.5 49.4h-68.9l-48.7-48.7v-70l49.4-49.5h69zM757 370.1v31.4l-31.2-31.4z",
    fill: "#EF4668"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M725 538.3h32v-32.1l12.3-12.3v56.8h-53l-1.9-1.8zM713.4 357.8h55.9v56L757 401.5v-31.4h-31.2z",
    fill: "#01A8C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M757 401.5v17.3l-48.7-48.7h17.5z",
    fill: "#EF4668"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M725 538.3l-10.6 10.6-0.7-0.7-2.3 2.5h-16.2l12.3-12.4z",
    fill: "#01A8C2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M707.5 538.3l49.5-49.4v17.3l-32 32.1z",
    fill: "#EF4668"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M716.3 550.7h-3.6l1.7-1.8z",
    fill: "#01A8C2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M713.7 548.2l0.7 0.7-1.7 1.8h-1.3zM712.7 550.7h3.6L877 707.2v17.1L705.7 557.7z",
    fill: "#01A8C2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M711.4 550.7h1.3l-7 7-0.6-0.6zM713.4 357.8l12.4 12.3h-17.5L696 357.8z",
    fill: "#01A8C2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M673.8 335.6l22.2 22.2h-44.3zM695.2 550.7l-22.1 22.1-22.2-22.1z",
    fill: "#EF4668"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M647.5 344.5l26.3-26.3 39.6 39.6H696l-22.2-22.2-22.1 22.2h-17.4zM650.9 550.7l22.2 22.1 22.1-22.1h16.2l-6.3 6.4 0.6 0.6-32.6 32.5-39.5-39.5z",
    fill: "#01A8C2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M673.8 318.2l-26.3 26.3-4.2-4.2-59.3-64.6h249c24.4 0 44.1 19.8 44.1 44.2V577l-92.3-98.5 24.7-24.7-40.1-40v-56h-55.9l-39.7-39.6z",
    fill: "#8CDDE4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M708.3 370.1h-69l12.4-12.3H696zM638.6 538.3h68.9l-12.3 12.4h-44.3z",
    fill: "#EF4668"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M584 275.7l59.3 64.6-9 8.4-67.2-73zM634.3 357.8h17.4l-12.4 12.3H622z",
    fill: "#01A8C2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M647.5 344.5l-13.2 13.3h-56.7v53.4L439.7 275.7h127.4l67.2 73 9-8.4z",
    fill: "#FFF0C2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M638.6 538.3l12.3 12.4h-17.3l-12.3-12.4z",
    fill: "#01A8C2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M589.9 370.1H622l-32.1 32.1zM621.3 538.3h-31.4V507z",
    fill: "#EF4668"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M622 370.1h17.3l-49.4 49.5v-17.4zM589.9 489.6l48.7 48.7h-17.3L589.9 507zM589.9 419.6v70l-12.3-12.3v-45.4z",
    fill: "#EF4668"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M589.9 370.1v32.1l-10.6 10.6-1.7-1.6v-53.4h56.7L622 370.1z",
    fill: "#01A8C2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M581.4 414.9l-2.1-2.1 10.6-10.6v17.4l-12.3 12.3v-13.1zM621.3 538.3l12.3 12.4h-56v-56l12.3 12.3v31.3z",
    fill: "#01A8C2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M589.9 489.6V507l-12.3-12.3v-17.4zM584 275.7h-16.9l-6.4-7 5.8-5.3h6.1zM581.4 414.9l-3.8 3.9v-4.3l1.7-1.7zM579.3 412.8l-1.7 1.7v-3.3z",
    fill: "#01A8C2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M577.6 431.9v45.4l-22.7-22.8z",
    fill: "#EF4668"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M577.6 411.2v3.3l-7.1 7-148.4-145.8h17.6z",
    fill: "#01A8C2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 421.5l7.1-7v4.3l-4.8 5zM569.8 260.3l2.8 3.1h-6.1z",
    fill: "#01A8C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M570.5 421.5l2.3 2.3 4.8-5v13.1l-22.7 22.6 22.7 22.8v17.4l-40.2-40.2zM560.7 268.7l6.4 7H439.7L429 265.2v-1.8h137.5zM446.4 441.7L227.9 706.4l-9.5-7.9 218.5-264.7z",
    fill: "#01A8C2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M446.2 619.8v41c0 11.9-9.6 21.5-21.5 21.5h-32.2c-11.9 0-21.5-9.6-21.5-21.5v-41c0-11.8 9.6-21.5 21.5-21.5h32.2c11.9 0 21.5 9.7 21.5 21.5z",
    fill: "#8CDDE4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M439.7 275.7h-17.6l-1.7-1.7 8.6-8.8zM446.2 660.8v-41c0-11.8-9.6-21.5-21.5-21.5h-32.2c-11.9 0-21.5 9.7-21.5 21.5v41c0 11.9 9.6 21.5 21.5 21.5h32.2c11.9 0.1 21.5-9.5 21.5-21.5z m12.3-41v41c0 18.7-15.1 33.8-33.8 33.8h-32.2c-18.7 0-33.8-15.1-33.8-33.8v-41c0-18.6 15.1-33.8 33.8-33.8h32.2c18.7 0 33.8 15.2 33.8 33.8z",
    fill: "#01A8C2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M297.1 467.6v36.9c0 12.9-10.6 23.5-23.6 23.5h-28.2c-13 0-23.6-10.6-23.6-23.5v-36.9c0-13 10.6-23.6 23.6-23.6h28.2c13-0.1 23.6 10.5 23.6 23.6z",
    fill: "#8CDDE4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M297.1 504.5v-36.9c0-13-10.6-23.6-23.6-23.6h-28.2c-13 0-23.6 10.6-23.6 23.6v36.9c0 12.9 10.6 23.5 23.6 23.5h28.2c13 0 23.6-10.6 23.6-23.5z m12.3-36.9v36.9c0 19.7-16.1 35.8-35.9 35.8h-28.2c-19.8 0-35.9-16.1-35.9-35.8v-36.9c0-19.8 16.1-35.9 35.9-35.9h28.2c19.7-0.1 35.9 16.1 35.9 35.9z",
    fill: "#01A8C2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M162.2 275.7c-20.9 0-37.9 17.1-37.9 38v431.8c0 26 21.2 47.1 47.1 47.1h649.3c31.1 0 56.4-25.2 56.4-56.4v-11.9l2 2 8.5-8.9h1.8v18.8c0 37.9-30.8 68.7-68.7 68.7H171.4c-32.7 0-59.4-26.7-59.4-59.4V313.7c0-27.8 22.5-50.3 50.2-50.3H429v1.8l-8.6 8.7 1.7 1.7H162.2z",
    fill: "#01A8C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/Coupons.e6bdd1a0b7b2b789ce7d7993ecaaaefe.svg";
export { ForwardRef as ReactComponent };